var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-listing-loader" },
    [
      _vm.displayHeaderLoader
        ? _c(
            "div",
            { staticClass: "email-listing-loader__header" },
            [
              _vm.displayResultsLoader
                ? _c("CompassSkeleton", {
                    staticClass: "email-listing-loader__results",
                    attrs: { size: "large" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.displaySearchLoader
                ? _c("CompassSkeleton", {
                    staticClass: "email-listing-loader__search",
                    attrs: { size: "large" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.displayRefreshLoader
                ? _c("CompassSkeleton", {
                    staticClass: "email-listing-loader__refresh",
                    attrs: { size: "large" }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(10, function(_, index) {
        return _c(
          "div",
          { key: index, staticClass: "email-listing-loader__body" },
          [_c("CompassSkeleton", { attrs: { size: "large" } })],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }